<template>
    <div class="wrapper" id="pageKb">
        <Header></Header>
        <SideBarPartial></SideBarPartial>
        <div class="content-wrapper">
            <Breadcrumb></Breadcrumb>
            <Card>
                <slot></slot>
                <template #action v-if="$slots.bottomAction">
                    <div class="d-flex align-items-center justify-content-end w-100">
                        <slot name="bottomAction"></slot>
                    </div>
                </template>
            </Card>
        </div>
        <!--    <FooterPartial></FooterPartial>-->
    </div>
</template>

<script>
import Header from './Header';
import SideBarPartial from './SideBar';
// import FooterPartial from '@/components/partials/layout/Footer'
import Breadcrumb from '@/components/partials/layout/Breadcrumb';
import Card from '@/components/partials/Card';
import { mapState } from 'vuex';
export default {
    name: 'mainPartial',
    props: {
        noPadding: {
            type: Boolean
        }
    },
    components: {
        // FooterPartial,
        SideBarPartial,
        Header,
        Breadcrumb,
        Card
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    mounted() {
        let namePage = this.$route.name;
        let arrPageShare = ['addShare', 'editShare'];
        if (!arrPageShare.includes(namePage)) {
            localStorage.removeItem('localSetStep');
            localStorage.removeItem('layoutPage2');
            localStorage.removeItem('layoutPage1');
            localStorage.removeItem('layoutPage3');
            localStorage.removeItem('layoutStep1');
            localStorage.removeItem('layoutStep2');
            localStorage.removeItem('layoutStep3');
            localStorage.removeItem('dataListConnect');
            localStorage.removeItem('dataListConnectViewStep3');
        }
        let userData = localStorage.getItem('KB_DEV_CUSTOMER') ? JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) : this.userInfo;
        let pageLoadData = ['shareList', 'memberList'];
        let routeName = this.$route.name;
        if ((userData && !userData.email) || pageLoadData.includes(routeName)) {
            this.getDataVerify();
        }
    },
    methods: {
        getDataVerify() {
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { user } = response.data.data;
                    this.$store.commit('auth/auth_success', { userInfo: user });
                    localStorage.setItem('KB_DEV_CUSTOMER', JSON.stringify(user));
                }
            };
            let errorCallback = () => {
                this.$store.commit('auth/auth_error');
            };
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('auth/verify', payload);
        }
    }
};
</script>

<style lang="scss">
.main-slim {
    padding: 0 0 0 75px !important;
}
.main {
    margin-top: 75px;
    display: flex;
    flex-direction: column;
    $main: &;
    .main-content {
        padding-top: 0 !important;
        margin-left: 240px;
        position: relative;
        .container-fluid {
            padding-right: 20px;
            padding-left: 20px;
        }
        &-body {
            min-height: calc(100vh - 135px);
        }
    }
    &__content {
        margin: 0 60px;
        padding: 0 75px 30px;
        background: #f5f5f5;
        flex-grow: 1;

        #{$main}--no-padding & {
            padding-right: 0;
            padding-left: 0;
        }

        &__breadcrumbs {
            @include regular-font(14px);

            line-height: 20px;
            text-align: left;
            color: #999999;
            padding: 24px 20px;

            a {
                color: #999999;
                text-decoration: none;
                cursor: pointer;
            }

            span {
                color: $black-color;
            }

            .mark {
                color: #999999;
            }
        }

        &__title {
            @include regular-font(25px);

            color: $sub-primary-color;
            line-height: 52px;
            text-align: center;
            margin-top: 0;

            .help-button {
                float: right;
            }
        }

        &__actions {
            margin-top: 47px;
        }
    }
    &-title {
        text-transform: uppercase;
        color: #031b4e;
        font-weight: bold;
        font-size: 30px;
        margin-bottom: 15px;
    }
}
.main-container {
    .dropdown .dropdown-menu {
        top: 64px !important;
    }
}
.page-wrapper {
    background-color: var(--color-custom) !important;
    .header-actions {
        i {
            color: var(--color-custom) !important;
        }
    }
    .table {
        thead {
            th {
                background-color: var(--color-custom) !important;
            }
        }
        tbody {
            .row-header {
                background-color: var(--color-custom) !important;
            }
        }
    }
    .thead {
        span {
            background-color: var(--color-custom) !important;
        }
    }
    .pagination-old__paginator ul li.active .page-link {
        background-color: var(--color-custom) !important;
        border-color: var(--color-custom) !important;
    }
    .sidebar-menu ul li a.current-page {
        color: var(--color-custom) !important;
        box-shadow: inset 3px 0 0 var(--color-custom) !important;
    }
    .sidebar-wrapper .sidebar-tabs .nav a.nav-link.active,
    .stats-tile2 .sale-icon {
        background-color: var(--color-custom-bg);
        i {
            color: var(--color-custom) !important;
        }
    }
    .el-button--primary,
    .btn-primary {
        background-color: var(--color-custom) !important;
        border-color: var(--color-custom) !important;
    }
    .stats-tile2 .sale-details,
    .stats-tiles-list .tiles-list h2,
    .sidebar-wrapper .sidebar-tabs .tab-content > .tab-pane .tab-pane-header,
    .field-placeholder,
    .field-wrapper .field-placeholder-top {
        color: var(--color-custom) !important;
    }
    .graph-day-selection .btn.active {
        color: var(--color-custom) !important;
        background-color: var(--color-custom-bg);
    }
    .form-check-input:checked {
        background-color: var(--color-custom);
        border-color: var(--color-custom);
    }
    .dialog-custom .el-dialog__header {
        background-color: var(--color-custom);
    }
}
</style>
